import useUserPermissions from "../../../../../../common/utils/user/permissions/use-user-permissions";
import operatorListingUserPermissionDefinition from "./operator-listing-user-permission";

const useOperatorListingUserPermissions = () => {
  return useUserPermissions(operatorListingUserPermissionDefinition);
};

export default useOperatorListingUserPermissions;
